import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SharedModule } from '../shared.module';
import { IColor, ISelectColorPopupComponentData, ISelectColorPopupComponentResult } from './interfaces';

@Component({
  standalone: true,
  templateUrl: 'select-color-popup.component.html',
  styleUrls: ['select-color-popup.component.css'],
  imports: [SharedModule]
})
export class SelectColorPopupComponent implements OnInit {
  colors: IColor[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ISelectColorPopupComponentData,
    private dialogRef: MatDialogRef<SelectColorPopupComponent, ISelectColorPopupComponentResult>
  ) {
  }

  ngOnInit(): void {
    this.colors = [
      // Red
      { value: '#d50000' },
      { value: '#ff1744' },
      { value: '#ff5252' },
      { value: '#ff8a80' },
      // Purple
      { value: '#aa00ff' },
      { value: '#d500f9' },
      { value: '#e040fb' },
      { value: '#ea80fc' },
      // Blue
      { value: '#2962ff' },
      { value: '#2979ff' },
      { value: '#448aff' },
      { value: '#82b1ff' },
      // Cyan
      { value: '#00b8d4' },
      { value: '#00e5ff' },
      { value: '#18ffff' },
      { value: '#84ffff' },
      // Green
      { value: '#00c853' },
      { value: '#00e676' },
      { value: '#69f0ae' },
      { value: '#b9f6ca' },
      // Yellow
      { value: '#ffd600' },
      { value: '#ffea00' },
      { value: '#ffff00' },
      { value: '#ffff8d' },
    ];
  }

  onSelectClick(color: IColor): void {
    const result: ISelectColorPopupComponentResult = { colorValue: color.value };
    this.dialogRef.close(result);
  }

  onCancelClick(): void {
    this.dialogRef.close();
  }
}
